import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateProductsTestData } from '../utils/productsTestDataGenerator';

export const GenerateProductsButton = () => {
  return (
    <GenerateTestDataButton
      label="Generate Test Products"
      generateFunction={generateProductsTestData}
      queryKey={['products']}
    />
  );
};